<template>
  <Card variant="outline" size="medium">
    <View gap="md" direction="column">
      <Text variant="h4">What to expect:</Text>
      <View v-for="item in items" :key="item.description" gap="md" direction="row">
        <IconTile size="small" color="blue" :icon="item.icon" />

        <View gap="xs" direction="column" :class="{ 'center-content': !item.title }">
          <Text variant="h4" v-if="item.title">{{ item.title }}</Text>
          <Text variant="body-medium" color="secondary">
            {{ item.description }}
          </Text>
        </View>
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { Card, IconTile, Text, View } from '../../index';
import { WhatToExpectItem } from './what-to-expect-item.interface';

defineProps<{
  items: WhatToExpectItem[];
}>();
</script>

<style scoped lang="scss">
.center-content {
  justify-content: center;
}
</style>
